export default __webpack_public_path__ + "static/media/charte-editoriale.dbb236b0.svg";